// generated by bun run generate from the SwiftUI SDK and codegen/catalog.ts.
// edit the generator or catalog, then regenerate.
import type { ColorValue, ViewProps } from 'react-native';
import type { Double } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
interface NativeProps extends ViewProps {
  material?: string;
  glassEffect?: string;
  interactive?: boolean;
  shape?: string;
  cornerRadius?: Double;
  tint?: ColorValue;
  colorScheme: string;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
let nativeComponentName = 'OneNativeGlass';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativeGlass",
  validAttributes: {
    material: true,
    glassEffect: true,
    interactive: true,
    shape: true,
    cornerRadius: true,
    tint: require('react-native/Libraries/Components/View/ReactNativeStyleAttributes').colorAttribute,
    colorScheme: true
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);